import { render, staticRenderFns } from "./ModalLinkRoblox.vue?vue&type=template&id=b06d2be6&scoped=true"
import script from "./ModalLinkRoblox.vue?vue&type=script&lang=js"
export * from "./ModalLinkRoblox.vue?vue&type=script&lang=js"
import style0 from "./ModalLinkRoblox.vue?vue&type=style&index=0&id=b06d2be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06d2be6",
  null
  
)

export default component.exports